import React, { useEffect, useRef, useState } from 'react';
import { Table, Alert, Button } from 'react-bootstrap';
import { useToggle } from '../../../hooks';
import { get } from '../../../utils/DeApi';
import Loader from '../../Loader/Loader';
import DeleteIcon from 'mdi-react/DeleteIcon';
import EditIcon from 'mdi-react/EditIcon';
import "./FormTypeList.scss";
import FormTypeModal from '../FormTypeModal/FormTypeModal';
import ErrorHandler from '../../ErrorHandler/ErrorHandler';

const FormTypeList = ({ refresh = false, user={} }) => {
  const [isFetching, toggleIsFetching] = useToggle(false);
  const [formTypes, setFormTypes] = useState([]);
  const [formType, setFormType] = useState(null);
  const [showModal, toggleShowModal] = useToggle(false);
  const [mode, setMode] = useState('Update');
  const subscribedPromises = useRef([]);
  const [error, setError] = useState(null);

  const handleEdit = (formType) => {
    setMode('Update');
    setFormType(formType);
  };

  const handleDelete = (formType) => {
    setMode('Delete');
    setFormType(formType);
  };

  const handleModalClose = (data, mode = 'Delete') => {
    toggleShowModal();
    setFormType(null);
    if (data) {
      switch(mode) {
        case 'Add': {
          setFormTypes([data, ...formTypes]);
          break;
        }
        case 'Update': {
          const types = formTypes.map((type) => {
            if(type.id === data.id) {
              type.name = data.name;
            }
            return type;
          })
          setFormTypes(types);
          break;
        }
        case 'Delete': {
          setFormTypes(formTypes.filter(type => type.id !== data.id));
          break;
        }
        default: return;
      }
    }
  }

  useEffect(() => {
    if (formType?.name) {
      toggleShowModal();
    }
  }, [formType, toggleShowModal]);

  useEffect(() => {
    const { promise , cancel } = get('formtypes', {params: {
      userEmail: user?.email || ''
    }});
    toggleIsFetching();
    promise.then((data) => {
      setFormTypes(data.data);
    })
    .catch((error) => setError(error))
    .finally(toggleIsFetching);
    subscribedPromises.current.push(cancel);
  }, [refresh, toggleIsFetching]);

  useEffect(() => {
    const promises = subscribedPromises.current;

    return () => promises.forEach((cancel) => cancel());
  }, []);

  if (isFetching) return <Loader />;
  if (formTypes.length === 0) return <NoData />;
  return (
    <>
      {error && <ErrorHandler error={error} />}
      <Table className="form-types table-hover" size="sm" >
        <thead>
          <tr>
            <th className='srWidth'>Sr.</th>
            <th className='nameWidth'>Name</th>
            <th className='actionBtnWidth'>Action</th>
          </tr>
        </thead>
        <tbody>
          {formTypes.map((formType, index) => <FormTypeRow key={index} formType={formType} serials={index} onEdit={handleEdit} onDelete={handleDelete} />)}
        </tbody>
      </Table>
      <FormTypeModal
        mode={mode}
        formType={formType}
        show={showModal}
        onClose={handleModalClose}
      />
    </>
  );
}

const FormTypeRow = ({ formType, onEdit, onDelete, serials }) => {
  return (
    <tr>
      <td className='srWidth'>{(serials >= 0) ? (serials + 1):''}</td>
      <td className='nameWidth'>{formType.name}</td>
      <td className='actionBtnWidth'>
        <Button
          variant="info"
          size="sm"
          className="p-1 rounded-circle littleRight"
          onClick={() => onEdit(formType)}
        >
          <EditIcon size={16} />
        </Button>
        <Button
          variant="warning"
          size="sm"
          className="p-1 ml-1 rounded-circle"
          onClick={() => onDelete(formType)}
        >
          <DeleteIcon size={16} />
        </Button>
      </td>
    </tr>
  );
}

const NoData = () => {
  return (
    <Alert className="mt-5" variant="info">
      <h4 className="mb-0">No items to show</h4>
    </Alert>
  );
}

export default FormTypeList;
